module.exports = __webpack_public_path__ + "img/about00.27e31777.png";